import * as userinfo from '@appStore/account/actions/user-info.actions';
import * as userregistration from '@appStore/account/actions/user-registration.actions';
import * as notifications from '@appStore/account/actions/notifications.actions';
import * as settings from '@appStore/account/actions/settings.actions';
import * as errors from '@appStore/account/actions/errors.actions';
import * as messages from '@appStore/account/actions/messages.actions';
import * as widget from '@appStore/account/actions/widget.actions';
import * as usernotificationsettings from '@appStore/account/actions/user-notification-settings.actions';
import * as filterviewsetting from '@appStore/account/actions/filter-view-settings.actions';

export * from '@appStore/account/actions/user-info.actions';
export * from '@appStore/account/actions/user-registration.actions';
export * from '@appStore/account/actions/notifications.actions';
export * from '@appStore/account/actions/settings.actions';
export * from '@appStore/account/actions/errors.actions';
export * from '@appStore/account/actions/messages.actions';
export * from '@appStore/account/actions/widget.actions';
export * from '@appStore/account/actions/user-notification-settings.actions';
export * from '@appStore/account/actions/filter-view-settings.actions';

export const ActionTypes = {
  ...userinfo.UserInfoActionTypes,
  ...notifications.NotificationActionTypes,
  ...userregistration.UserRegistrationActionTypes,
  ...settings.SettingActionTypes,
  ...errors.ErrorActionTypes,
  ...messages.MessageActionTypes,
  ...widget.WidgetActionTypes,
  ...usernotificationsettings.UserNotificationSettingActionTypes,
  ...filterviewsetting.FilterViewSettingActionTypes,
};

export type Actions =
  | notifications.NotificationActions
  | userinfo.UserInfoActions
  | userregistration.UserRegistrationActions
  | settings.SettingActions
  | errors.ErrorsActions
  | messages.MessageActions
  | widget.WidgetActions
  | usernotificationsettings.UserNotificationSettingAction
  | filterviewsetting.FilterViewSettingActions
